/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For more information visit: https://egtuniverse.com/legal
 *
 * Created for Universe App Tools.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "email.security",
    title: "Email Security Notice",
    description: "Static \"Be safe,\" security section included in all platform auth emails. Contains 6 best-practice reminders.",
    supportServer: true,
    control: false,
    foruseIn: ["email"],
    fields: {}
});
var $ = require("../../../uam/scafolding.js");

var SECURITY_ITEMS = [
    "Never share this code or link with anyone you don't fully trust.",
    "Don't forward or share this email with others.",
    "The Universe will never ask you for your sign-in code - if someone does, it's probably a scam.",
    "Only enter codes in the browser tab where you requested them.",
    "Codes expire - use them promptly; request a new one if needed.",
    "If you didn't request this, you can safely ignore it - nothing will happen."
];

exports.render = async function (options) {
    var { html } = await exports.renderEmail(options);
    return [{
        n: "ua.element.serverNotSupported",
        inner: {
            n: "json",
            type: "ua/interface",
            by: "email.security",
            i: JSON.stringify({
                n: "html",
                html: `<div style="max-width:480px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;">${html}</div>`
            })
        }
    }];
};

exports.renderEmail = async function (options) {
    var cfg = $.config || {};
    var primary = (cfg.my && cfg.my.app && cfg.my.app.colors && cfg.my.app.colors.primary) || "#C48D2F";
    var text = (cfg.my && cfg.my.app && cfg.my.app.colors && cfg.my.app.colors.text) || "#000000";
    var listItems = "";
    var textLines = [];

    var i = 0;
    while (i < SECURITY_ITEMS.length) {
        listItems += `<li style="margin-bottom:8px;font-family:Arial,Helvetica,sans-serif;font-size:14px;color:${text};line-height:1.5;">${SECURITY_ITEMS[i]}</li>`;
        textLines.push((i + 1) + ". " + SECURITY_ITEMS[i]);
        i++;
    }

    var html = `<tr>
  <td style="padding:20px 20px 10px 20px;">
    <h2 style="margin:0 0 12px 0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:18px;font-weight:bold;color:${primary};">
      Be safe,
    </h2>
    <ol style="margin:0;padding:0 0 0 20px;">
      ${listItems}
    </ol>
  </td>
</tr>`;

    var text = "Be safe,\n\n" + textLines.join("\n");

    return { html, text };
};
